export default __webpack_public_path__ + "static/media/Conceptual_Architecture_Flow_Thumnail_Image.dec9442f.png";